import { render, staticRenderFns } from "./DrzavaCreate.vue?vue&type=template&id=c4469878&scoped=true&"
import script from "./DrzavaCreate.vue?vue&type=script&lang=js&"
export * from "./DrzavaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4469878",
  null
  
)

export default component.exports